import React from "react";
import { DragAndDropList } from "./DragAndDropList";

interface ExperienceChecklistProps {
    included?: string[];
    excluded?: string[];
    handleIncludedChange: (items: string[]) => void;
    handleNotIncludedChange: (items: string[]) => void;
}

export const ExperienceChecklist = ({
    included = [],
    excluded = [],
    handleIncludedChange,
    handleNotIncludedChange,
}: ExperienceChecklistProps) => {
    return (
        <>
            <h6 className="font-bold">Checklist</h6>
            <div className="flex flex-auto space-x-2">
                <div className="w-1/2">
                    <h6 className="font-bold">What&apos;s Included</h6>
                    <DragAndDropList
                        listType="included"
                        items={included}
                        handleIncludedChange={handleIncludedChange}
                        handleNotIncludedChange={handleNotIncludedChange}
                    />
                </div>

                <div className="w-1/2">
                    <h6 className="font-bold">What to Bring</h6>
                    <DragAndDropList
                        listType="excluded"
                        items={excluded}
                        handleIncludedChange={handleIncludedChange}
                        handleNotIncludedChange={handleNotIncludedChange}
                    />
                </div>
            </div>
        </>
    );
};
